import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path data-name="Selection Control / Checkbox / On / Enabled" d="M21.333 0H2.667A2.666 2.666 0 000 2.667v18.667A2.666 2.666 0 002.667 24h18.666A2.666 2.666 0 0024 21.333V2.666A2.666 2.666 0 0021.333 0zm-12 18.667L2.667 12l1.88-1.88 4.787 4.773 10.12-10.12 1.88 1.893z" fill="#1791dd" /></svg>);